<template>
<div>
  <loading :active.sync="isLoading" :loader="'dots'"  :color="'#2759ab'" :can-cancel="false" :is-full-page="true"></loading>
  <div class="container" v-if="step1">
    <div class="row mb-5">
      <div class="getting_loan_area gla_2 col-lg-12 back-form">
        <div class="row getting_inner">
          <div class="col-lg-12 getting_first">
            <div class="tittle">
              <h2>Datos personales</h2>
            </div>
             <div class="col-lg-12">
               <form>
                 <div class="row">
                   <div class="col-lg-6 col-md-12 select_from pb-3">
                     <h6>Nombre(s)*</h6>
                     <input type="text" class="post_input_quote" id="names" name="names" v-model="detailsData.names" :class="{ 'error': $v.detailsData.names.$invalid }">
                   </div>
                    <div class="col-lg-6 col-md-12 select_from pb-3">
                     <h6>Apellido paterno*</h6>
                     <input type="text" class="post_input_quote" id="father_name" name="father_name" v-model="detailsData.father_name" :class="{ 'error': $v.detailsData.father_name.$invalid }">
                   </div>
                    <div class="col-lg-6 col-md-12 select_from pb-3">
                     <h6>Apellido materno*</h6>
                     <input type="text" class="post_input_quote" id="mother_name" name="mother_name" v-model="detailsData.mother_name" :class="{ 'error': $v.detailsData.mother_name.$invalid }">
                   </div>
                   <!-- <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Fecha de nacimiento*</h6>
                    <div class="input-icons2">
                      <input readonly class="post_select_quote" id="birth_date2" name="birth_date" style="cursor: pointer">
                      <i class="fa fa-angle-down icon" style="color: black" v-on:click=selectDate()></i>
                    </div>
                   </div> -->
                   <div class="col-lg-6 col-md-12 select_from pb-3">
                     <h6>Estado civil*</h6>
                     <select class="post_select_quote" id="estado_civil" :class="{ 'error': $v.detailsData.marital_status.$invalid }">
                      <option value="Soltero">Soltero</option>
                      <option value="Casado">Casado</option>
                      <option value="Divorciado">Divorciado</option>
                      <option value="Viudo">Viudo</option>
                      <option value="Concubinato">Concubinato</option>
                    </select>
                   </div>
                   <div class="col-lg-6 col-md-12 select_from pb-3">
                     <h6>RFC*</h6>
                     <input type="text" class="post_input_quote" id="rfc2" name="rfc2" v-model="detailsData.rfc" :class="{ 'error': $v.detailsData.rfc.$invalid }">
                   </div>
                   <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Tipo de entidad*</h6>
                    <select class="post_select_quote" id="entity" :class="{ 'error': $v.detailsData.entity.$invalid }">
                      <option value="Moral">Moral</option>
                      <option value="Fisica">Física</option>
                    </select>
                   </div>
                   <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Razón social (Opcional)</h6>
                    <input type="text" class="post_input_quote" id="business_name" name="business_name" v-model="detailsData.business_name">
                   </div>
                   <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Fecha de constancia (Opcional)</h6>
                    <div class="input-icons2">
                      <input readonly class="post_select_quote" id="constancy_date" name="constancy_date" style="cursor: pointer">
                      <i class="fa fa-angle-down icon" style="color: black" v-on:click=selectDate2()></i>
                    </div>
                   </div>
                   <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Fecha de factura (Opcional)</h6>
                    <div class="input-icons2">
                      <input readonly class="post_select_quote" id="invoice_date" name="invoice_date" style="cursor: pointer">
                      <i class="fa fa-angle-down icon" style="color: black" v-on:click=selectDate4()></i>
                    </div>
                   </div>
                   <!-- <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Fecha de inicio</h6>
                    <div class="input-icons2">
                      <input readonly class="post_select_quote" id="start_date" name="start_date" style="cursor: pointer">
                      <i class="fa fa-angle-down icon" style="color: black" v-on:click=selectDate5()></i>
                    </div>
                   </div>
                   <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Fecha de fin</h6>
                    <div class="input-icons2">
                      <input readonly class="post_select_quote" id="end_date" name="end_date" style="cursor: pointer">
                      <i class="fa fa-angle-down icon" style="color: black" v-on:click=selectDate6()></i>
                    </div>
                   </div> -->
                 </div>
                 <div class="row">
                  <div class="col-lg-12 text-uppercase">
                    <div class="tittle">
                      <h2 style="font-size: 26px;color: black;">Domicilio</h2>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Calle*</h6>
                    <input type="text" class="post_input_quote" id="street" name="street" v-model="detailsData.street" :class="{ 'error': $v.detailsData.street.$invalid }">
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Numero exterior*</h6>
                    <input type="text" class="post_input_quote" id="exterior_no" name="exterior_no" v-model="detailsData.exterior_no" :class="{ 'error': $v.detailsData.exterior_no.$invalid }">
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Numero interior (Opcional)</h6>
                    <input type="text" class="post_input_quote" id="interior_no" name="interior_no" v-model="detailsData.interior_no">
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Código postal*</h6>
                    <input type="text" class="post_input_quote" id="zip_code" name="zip_code" v-model="detailsData.zip_code" :class="{ 'error': $v.detailsData.zip_code.$invalid }">
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Colonia*</h6>
                    <input type="text" class="post_input_quote" id="suburb" name="suburb" v-model="detailsData.suburb" :class="{ 'error': $v.detailsData.suburb.$invalid }">
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Estado*</h6>
                    <select class="post_select_quote" id="state" v-model="detailsData.state" :class="{ 'error': $v.detailsData.state.$invalid }">
                      <option value="">Estado</option>
                      <option v-for="state in states">{{state}}</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Ciudad*</h6>
                    <select class="post_select_quote" id="city" v-model="detailsData.city" :disabled="detailsData.state == ''" :class="{ 'error': $v.detailsData.city.$invalid }">
                      <option value="">Ciudad</option>
                      <option v-for="township in townships">{{township}}</option>
                    </select>
                  </div>
                 </div>
                 <div class="row">
                  <div class="col-lg-12 text-uppercase">
                    <div class="tittle">
                      <h2 style="font-size: 26px;color: black;">Beneficiario (Opcional)</h2>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Nombre</h6>
                    <input type="text" class="post_input_quote" id="beneficiary_name" name="beneficiary_name" v-model="detailsData.beneficiary_name" >
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Fecha de nacimiento</h6>
                    <div class="input-icons2">
                      <input readonly class="post_select_quote" id="beneficiary_birth_date" name="beneficiary_birth_date" style="cursor: pointer">
                      <i class="fa fa-angle-down icon" style="color: black" v-on:click=selectDate3()></i>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>RFC</h6>
                    <input type="text" class="post_input_quote" id="beneficiary_rfc" name="beneficiary_rfc" v-model="detailsData.beneficiary_rfc" :class="{ 'error': $v.detailsData.beneficiary_rfc.$invalid && $v.detailsData.beneficiary_rfc.$dirty }">
                  </div>
                 </div>
                 <div class="row">
                  <div class="col-lg-12 text-uppercase">
                    <div class="tittle">
                      <h2 style="font-size: 26px;color: black;">Datos del vehículo</h2>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Número de serie*</h6>
                    <input type="text" class="post_input_quote" id="serial_number" name="serial_number" v-model="detailsData.serial_number" :class="{ 'error': $v.detailsData.serial_number.$invalid }">
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Tipo de vehículo*</h6>
                    <select class="post_select_quote" id="vehicle_type" :class="{ 'error': $v.detailsData.vehicle_type.$invalid }">
                      <option value="Auto_Particulares">Auto Particulares</option>
                      <option value="Motos_Particulares">Motos Particulares</option>
                      <option value="Pick_Ups">Pick Ups</option>
                      <option value="Pick_Ups_Carga">Pick Ups Carga</option>
                      <option value="Camiones">Camiones</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Placas*</h6>
                    <input type="text" class="post_input_quote" id="plates" name="plates" v-model="detailsData.plates" :class="{ 'error': $v.detailsData.plates.$invalid }">
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                   <h6>Transmisión*</h6>
                    <select class="post_select_quote" id="transmission" :class="{ 'error': $v.detailsData.transmission.$invalid }">
                      <option value="Manual">Manual</option>
                      <option value="Automático">Automático</option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-md-12 select_from pb-3">
                    <h6>Pasajeros*</h6>
                    <input type="text" class="post_input_quote" maxlength="1" id="passengers" name="passengers" v-only-numbers v-model="detailsData.passengers" :class="{ 'error': $v.detailsData.passengers.$invalid }">
                  </div>
                 </div>
                 <div class="row pb-3">
                   <div class="col-lg-12 d-flex justify-content-end">
                     <button type="button" class="theme_btn btn" v-on:click="nextStep2()">Siguiente</button>
                   </div>
                 </div>
               </form>
             </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container" v-if="step2">
    <div class="row mb-5">
      <div class="getting_loan_area gla_2 col-lg-5 offset-lg-1 back-form">
          <div class="row getting_inner">
              <div class="col-12 text-center title-seguro">
                  <h6>DATOS DEL VEHÍCULO</h6>
                  <hr>
              </div>
              <div class="col-6 data-items">
                  <h3>Modelo</h3>
                  <p>{{dataContractor.selectedModel}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Marca</h3>
                  <p>{{dataContractor.selectedBrand}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Versión</h3>
                  <p>{{dataContractor.selectedVersion}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Descripción</h3>
                  <p>{{dataContractor.selectedDescription}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Número de serie</h3>
                  <p>{{detailsData.serial_number}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Placas</h3>
                  <p>{{detailsData.plates}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Tipo de vehículo</h3>
                  <p v-if="detailsData.vehicle_type == 'Auto_Particulares'">Auto particulares</p>
                  <p v-if="detailsData.vehicle_type == 'Motos_Particulares'">Motos particulares</p>
                  <p v-if="detailsData.vehicle_type == 'Pick_Ups'">Pick ups</p>
                  <p v-if="detailsData.vehicle_type == 'Pick_Ups_Carga'">Pick ups carga</p>
                  <p v-if="detailsData.vehicle_type == 'Camiones'">Camiones</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Transmisión</h3>
                  <p>{{detailsData.transmission}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Pasajeros</h3>
                  <p>{{detailsData.passengers}}</p>
              </div>
          </div>
      </div>
      <div class="getting_loan_area gla_2 col-lg-5 back-form">
          <div class="row getting_inner">
              <div class="col-12 text-center title-seguro">
                  <h6>DATOS DEL SOLICITANTE</h6>
                  <hr>
              </div>
              <div class="col-12 data-items">
                  <h3>Nombre</h3>
                  <p>{{dataContractor.fullName}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Sexo</h3>
                  <p>{{dataContractor.gender}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Edad</h3>
                  <p>{{dataContractor.age}}</p>
              </div>
              <div class="col-12 data-items">
                  <h3>Email</h3>
                  <p>{{dataContractor.email}}</p>
              </div>
              <div class="col-12 data-items">
                  <h3>Teléfono</h3>
                  <p>{{dataContractor.phone}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Código postal</h3>
                  <p>{{dataContractor.postcode}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Forma de pago</h3>
                  <p>{{dataContractor.paymentMethod}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Fecha de nacimiento</h3>
                  <p>{{dataContractor.birthDay}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Estado civil</h3>
                  <p>{{detailsData.marital_status}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>RFC</h3>
                  <p>{{detailsData.rfc}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Tipo de entidad</h3>
                  <p>{{detailsData.entity}}</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Razón social (Opcional)</h3>
                  <p v-if="detailsData.business_name">{{detailsData.business_name}}</p>
                  <p v-if="!detailsData.business_name">N/D</p>
              </div>
              <div class="col-6 data-items">
                  <h3>Fecha constancia (Opcional)</h3>
                  <p v-if="detailsData.constancy_date">{{detailsData.constancy_date}}</p>
                  <p v-if="!detailsData.constancy_date">N/D</p>
              </div>
              <div class="col-6 data-items">
                <h3>Fecha de factura</h3>
                <p>{{detailsData.invoice_date}}</p>
                <p v-if="!detailsData.invoice_date">N/D</p>
              </div>
          </div>
      </div>
      <div class="getting_loan_area gla_2 col-lg-5 offset-lg-1 back-form">
        <div class="row getting_inner">
          <div class="col-12 text-center title-seguro">
            <h6>DOMICILIO</h6>
            <hr>
          </div>
          <div class="col-6 data-items">
            <h3>Calle</h3>
            <p>{{detailsData.street}}</p>
          </div>
          <div class="col-6 data-items">
            <h3>Número exterior</h3>
            <p>{{detailsData.exterior_no}}</p>
          </div>
          <div class="col-6 data-items">
            <h3>Número interior (Opcional)</h3>
            <p v-if="detailsData.interior_no">{{detailsData.interior_no}}</p>
            <p v-if="!detailsData.interior_no">N/D</p>
          </div>
          <div class="col-6 data-items">
            <h3>Código postal</h3>
            <p>{{detailsData.zip_code}}</p>
          </div>
          <div class="col-6 data-items">
            <h3>Colonia</h3>
            <p>{{detailsData.suburb}}</p>
          </div>
          <div class="col-6 data-items">
            <h3>Estado</h3>
            <p>{{detailsData.state}}</p>
          </div>
          <div class="col-6 data-items">
            <h3>Ciudad</h3>
            <p>{{detailsData.city}}</p>
          </div>
        </div>
      </div>
      <div class="getting_loan_area gla_2 col-lg-5 back-form">
        <div class="row getting_inner">
          <div class="col-12 text-center title-seguro">
            <h6>DATOS DEL SEGURO</h6>
            <hr>
          </div>
          <div class="col-6 data-items">
            <h3>Compañia</h3>
            <img style="width: 100px" src="images/socios2/qualitas.png" v-if="dataInsurance.cia == 'qualitas'">
            <img style="width: 100px" src="images/socios2/mapfre.png" v-if="dataInsurance.cia == 'mapfre'">
            <img style="width: 100px" src="images/socios2/afirme.png" v-if="dataInsurance.cia == 'afirme'">
            <img style="width: 100px" src="images/socios2/chubb.png" v-if="dataInsurance.cia == 'chubb'">
            <img style="width: 100px" src="images/socios2/hdi.png" v-if="dataInsurance.cia == 'hdi'">
            <img style="width: 100px" src="images/socios2/gnp.png" v-if="dataInsurance.cia == 'gnp'">
            <img style="width: 100px" src="images/socios2/zurich.png" v-if="dataInsurance.cia == 'zurich'">
            <img style="width: 100px" src="images/socios2/ana.png" v-if="dataInsurance.cia == 'ana'">
          </div>
          <div class="col-6 data-items">
            <h3>Daño material</h3>
            <p>{{dataInsurance.material_damage}}%</p>
          </div>
          <div class="col-6 data-items">
            <h3>Robo total</h3>
            <p>{{dataInsurance.steal_total}}%</p>
          </div>
          <div class="col-6 data-items" v-if="dataContractor.paymentMethod != 'Contado'">
            <h3>Pago inicial</h3>
            <p>${{formatPrice(dataInsurance.initial_payment)}}</p>
          </div>
          <div class="col-6 data-items" v-if="dataContractor.paymentMethod != 'Contado'">
            <h3>Pagos</h3>
            <p>${{formatPrice(dataInsurance.payments)}}</p>
          </div>
          <div class="col-6 data-items">
            <h3>Precio total</h3>
            <p>${{formatPrice(dataInsurance.price_total)}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row pb-3">
      <div class="col-lg-12 d-flex justify-content-end">
        <button type="button" class="theme_btn btn" v-on:click="nextStep3()">Siguiente</button>
      </div>
    </div>
  </div>
  <div class="container" v-if="step3">
    <div class="row mb-5">
      <div class="getting_loan_area gla_2 col-lg-12 back-form">
        <div class="row getting_inner">
          <div class="col-lg-12 getting_first">
            <div class="tittle">
              <h2>Método de pago</h2>
            </div>
          </div>
          <div class="col-lg-12 mb-5">
            <form>
              <div class="row">
                <div class="col-lg-6 col-md-12 select_from">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" id="bank_account" value="bank_account" v-model="pay_method">
                    <label class="custom-control-label" for="bank_account">Transferencia bancaria</label>
                  </div>
                  <span style="padding: 0px 0px 25px 35px; font-size: 18px; font-weight: 500;">Credimóvil</span>
                </div>
                <div class="col-lg-6 col-md-12 select_from">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" id="card" value="card" v-model="pay_method">
                    <label class="custom-control-label" for="card">Pago con tarjeta de crédito/débito</label>
                  </div>
                </div>
                <div class="col-lg-6 col-md-12 select_from">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" class="custom-control-input" id="store" value="store" v-model="pay_method">
                    <label class="custom-control-label" for="store">Pago en tienda</label>
                  </div>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-lg-12 d-flex justify-content-end">
                  <button type="button" class="theme_btn btn" v-on:click="nextStep4()">Continuar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container" :style="[ !stepCard ? { 'display': 'none' } : { 'display': 'block'} ]">
    <div class="row mb-5">
      <div class="getting_loan_area gla_2 col-lg-12 back-form">
        <div class="row getting_inner">
          <div class="col-lg-12 getting_first">
            <div class="tittle">
              <h2>Tarjeta de crédito/débito</h2>
            </div>
          </div>
          <div class="col-lg-6 col-md-12 pb-3 border-box">
            <div class="row">
              <div class="col-lg-12 pb-3">
                <h4 style="color: #f59019; font-weight: 600">Detalles de la compra:</h4>
              </div>
              <div class="col-lg-6 pb-3">
                <h5 style="color: #2759ab; font-weight: 600">Orden No.</h5>
                <p>{{ policy }}</p>
              </div>
              <div class="col-lg-6 pb-3">
                <h5 style="color: #2759ab; font-weight: 600">Nombre</h5>
                <p>Maria Filomena Avena Díaz</p>
              </div>
              <div class="col-lg-6 pb-3">
                <h5 style="color: #2759ab; font-weight: 600">Total</h5>
                <p>MXN ${{ pricePolicy }}</p>
              </div>
            </div>
          </div> 
          <div class="col-lg-6 col-md-12 pb-3 border-box">
            <div class="row">
              <div class="col-lg-12 pb-3">
                <h4 style="color: #f59019; font-weight: 600">Productos:</h4>
              </div>
              <div class="col-lg-6 pb-3">
                <img src="https://wwwidentoes-ans9ff0uc6be.stackpathdns.com/wp-content/plugins/accelerated-mobile-pages/images/SD-default-image.png" style="width: 65%;">
              </div>
              <div class="col-lg-6 pb-3">
                <!-- <h5 style="color: #2759ab; font-weight: 600">{{ policy }}</h5> -->
                <p>SEGURO DE AUTO</p>
                <p>CANTIDAD: 1</p>
                <p>MXN ${{ pricePolicy }}</p>
                <p>TOTAL: MXN ${{ pricePolicy }}</p>
              </div>
              <!-- <div class="col-lg-6 offset-lg-6 pb-3">
                <h5 style="color: #2759ab; font-weight: 600">Envío</h5>
                <p>Total: $0.00</p>
              </div> -->
            </div>
          </div>
          <div class="col-lg-12 pt-4 pb-4">
            <h5>El pago aparecerá con la siguiente descripción: </h5>
            <p>Pago por compra de productos Credimóvil con el número de orden {{ policy }}</p>
          </div>
          <div class="col-lg-12 ">
            <div class="row">
              <div class="col-lg-12 text-uppercase ">
                <div class="tittle">
                  <h2 style="font-size: 26px;color: black;">Tarjetas aceptadas</h2>
                </div>
              </div>
              <div class="col-lg-5 col-md-6 col-sm-12">
                <div class="row">
                  <div class="col-lg-12">
                    <h5 class="text-center">Tarjeta de crédito</h5>
                  </div>
                  <div class="col-lg-12 pl-lg-5 pt-3">
                    <img src="images/tarjetas/visa.png" style="width: 10%; margin-left: 12%;">
                    <img src="images/tarjetas/mastercard.png" style="width: 10%; margin-left: 12%;">
                    <img src="images/tarjetas/american.png" style="width: 10%; margin-left: 12%;">
                    <img src="images/tarjetas/carnet.png" style="width: 10%; margin-left: 12%;">
                  </div>
                </div>
              </div>
              <div class="col-lg-7 col-md-6 col-sm-12">
                <div class="row">
                  <div class="col-lg-12">
                    <h5 class="text-center">Tarjeta de débito</h5>
                  </div>
                  <div class="col-lg-12 pt-3">
                    <img src="images/tarjetas/bbva.png" style="width: 8%; margin-left: 7%;">
                    <img src="images/tarjetas/santander.png" style="width: 8%; margin-left: 7%;">
                    <img src="images/tarjetas/hsbc.png" style="width: 8%; margin-left: 7%;">
                    <img src="images/tarjetas/scotiabank.png" style="width: 8%; margin-left: 7%;">
                    <img src="images/tarjetas/inbursa.jpg" style="width: 8%; margin-left: 7%;">
                    <img src="images/tarjetas/ixe.png" style="width: 8%; margin-left: 7%;">
                  </div>
                </div>
              </div>
              <div class="col-lg-12 pt-5 pb-4">
                <div class='card-wrapper'></div>
              </div>
              <div class="col-lg-12">
                <form id="formId">
                  <div class="row">
                    <div class="col-lg-6 col-md-12 select_from pb-3">
                      <h6>Tipo de tarjeta</h6>
                      <select class="post_select_quote" id="card_type" :class="{ 'error': $v.cardData.type.$invalid }">
                        <option value="Débito">Débito</option>
                        <option value="Crédito">Crédito</option>
                      </select>
                    </div>
                    <div class="col-lg-6 col-md-12 select_from pb-3">
                      <h6>Nombre del títular</h6>
                      <input class="post_input_quote" type="text" name="name" v-model="cardData.name" :class="{ 'error': $v.cardData.name.$invalid }">
                    </div>
                    <div class="col-lg-6 col-md-12 select_from pb-3">
                      <h6>Número de tarjeta</h6>
                      <input class="post_input_quote" type="text" maxlength="19" name="number" v-model="cardData.number" :class="{ 'error': $v.cardData.number.$invalid }">
                    </div>
                    <div class="col-lg-6 col-md-12 select_from pb-3">
                      <h6>Vencimiento</h6>
                      <input class="post_input_quote" type="text" name="expiry" v-model="cardData.expiry" :class="{ 'error': $v.cardData.expiry.$invalid }">
                    </div>
                    <div class="col-lg-6 col-md-12 select_from pb-3">
                      <h6>CVV</h6>
                      <input class="post_input_quote" type="password" name="cvc" v-model="cardData.cvv" :class="{ 'error': $v.cardData.cvv.$invalid }">
                    </div>
                    <div class="col-lg-12 d-flex justify-content-end">
                      <button type="button" class="theme_btn btn" v-on:click="generatePay()" :disabled="$v.cardData.$invalid">Generar pago</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-lg-12 pt-5 pb-4">
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <img src="images/tarjetas/openpay.png" style="width: 45%">
              </div>
              <div class="col-lg-6 col-md-12">
                <img src="images/tarjetas/encrip.png" style="width: 18%">
                Tus pagos se realizan de forma segura con encriptación de 256 bits.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container" v-if="stepFinal">
    <div class="row mb-5">
      <div class="getting_loan_area gla_2 col-lg-12 back-form">
        <div class="row getting_inner">
          <div class="col-lg-12 getting_first">
            <div class="tittle">
              <h2>Pago realizado con éxito</h2>
            </div>
          </div>
          <div class="col-lg-12 ">
            <h5 class="text-center">Una copia de su póliza ha sido enviada a su correo electrónico</h5>
            <h5 class="text-center">Gracias por confiar en Credimóvil</h5>
          </div>
          <div class="col-lg-12 d-flex align-content-end pt-5">
            <a href="/" class="btn theme_btn ml-auto">Ir al incio</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  
</template>

<script>
import { required, minLength, between, maxValue, minValue, email } from 'vuelidate/lib/validators';
import statesAndTownship from '../assets/estados-municipios.json';

var regexEmail = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
var regexPhone = /^([0-9])*$/;
var regexRfc = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;

export default {
  name: 'QuotationProcess',
  props: {
    dataContractor: {
      id: 0,
      fullName: '',
      age: '',
      birthDay: '',
      email: '',
      phone: '',
      gender: '',
      postcode: '',
      paymentMethod: '',
      selectedModel: '',
      selectedBrand: '',
      selectedVersion: '',
      selectedDescription: ''
    },
    dataInsurance: {
      id: 0,
      cia: '',
      duty: '',
      initial_payment: 0,
      iva: '',
      material_damage: 0,
      net_price: '',
      payments: '',
      price_total: '',
      recharges: '',
      steal_total: 0
    },
    vehicleKey: '',
  },
  data() {
    return {
      arrayValidations: [],
      states: [],
      townships: [],
      step1: true,
      step2: false,
      step3: false,
      stepCard: false,
      stepFinal: false,
      isLoading: false,
      models: [],
      brands: [],
      versions: [],
      descriptions: [],
      pay_method: '',
      token: '',
      endpoint_sandbox_openpay: 'https://sandbox-api.openpay.mx/v1/',
      endpoint_payament: 'you_host/api/charge',
      deviceSessionId: '',
      openpay_id: 'mepd5ufg3yus1qycakcs',
      openpay_key: 'pk_9f6ec98a6c024c349d05fa6f39852cc1',
      openpay_sandbox_mode: true,
      policieId: 0,
      pricePolicy: 0,
      policy: '',
      data: {
        fullName: '',
        age: '',
        email: '',
        phone: '',
        gender: '',
        postcode: '',
        paymentMethod: '',
        selectedModel: '',
        selectedBrand: '',
        selectedVersion: '',
        selectedDescription: '',
        id: 0,
        cia: '',
        material_damage: '',
        steal_total: '',
        initial_payment: 0
      },
      detailsData: {
        names: '',
        father_name: '',
        mother_name: '',
        birth_date: '',
        marital_status: 'Soltero',
        rfc: '',
        entity: 'Fisica',
        business_name: '',
        constancy_date: '',
        street: '',
        exterior_no: '',
        interior_no: '',
        zip_code: '',
        suburb: '',
        state: '',
        city: '',
        beneficiary_name: '',
        beneficiary_birth_date: '',
        beneficiary_rfc: '',
        serial_number: '',
        plates: '',
        vehicle_type: 'Auto_Particulares',
        invoice_date: '',
        transmission: 'Manual',
        passengers: '',
        start_date: '',
        end_date: '',
      },
      cardData: {
        type: 'Débito',
        name: '',
        number: '',
        expiry: '',
        cvv: '',
      },
    }
  },
  validations() {
    return {
      detailsData: {
        names: { required },
        father_name: { required },
        mother_name: { required },
        marital_status: { required },
        rfc: { required, validateRfc: (value) => { return regexRfc.test(value); } },
        entity: { required },
        street: { required },
        exterior_no: { required },
        zip_code: { required },
        suburb: { required },
        state: { required },
        city: { required },
        beneficiary_rfc: { validateRfc: (value) => { return regexRfc.test(value); } },
        serial_number: { required },
        plates: { required },
        vehicle_type: { required },
        passengers: { required, minLength: minLength(1) },
        transmission: { required },
      },
      cardData: {
        type: { required },
        name: { required },
        number: { required, minLength: minLength(19)},
        expiry: { required, minLength: minLength(9) },
        cvv: { required },
      }
    }
    
  },
  methods: {
    validateForm() {
      var errors = 0;

      if (this.detailsData.marital_status == '') { errors++; this.arrayValidations.push('Estado civil'); } 
      // if (this.detailsData.birth_date == '') { errors++; this.arrayValidations.push('Fecha de nacimiento'); } 
      if (this.detailsData.rfc == '') { errors++; this.arrayValidations.push('RFC'); } 
      if (this.detailsData.entity == '') { errors++; this.arrayValidations.push('Tipo de entidad'); } 
      if (this.detailsData.street == '') { errors++; this.arrayValidations.push('Calle'); } 
      if (this.detailsData.exterior_no == '') { errors++; this.arrayValidations.push('Número exterior'); } 
      if (this.detailsData.zip_code == '') { errors++; this.arrayValidations.push('Código postal'); } 
      if (this.detailsData.suburb == '') { errors++; this.arrayValidations.push('Colonia'); } 
      if (this.detailsData.state == '') { errors++; this.arrayValidations.push('Estado'); } 
      if (this.detailsData.city == '') { errors++; this.arrayValidations.push('Ciudad'); } 
      if (this.detailsData.serial_number == '') { errors++; this.arrayValidations.push('Número serial'); } 
      if (this.detailsData.plates == '') { errors++; this.arrayValidations.push('Placas'); } 
      if (this.detailsData.vehicle_type == '') { errors++; this.arrayValidations.push('Tipo de vehículo'); } 
      if (this.detailsData.transmission == '') { errors++; this.arrayValidations.push('Transmisión'); } 
      if (this.detailsData.passengers == '') { errors++; this.arrayValidations.push('Pasajeros'); } 
      return (errors > 0);
    }, 
    selectDate() {
      $('#birth_date2').datepicker('show');
    },
    selectDate2() {
      $('#constancy_date').datepicker('show');
    },
    selectDate3() {
      $('#beneficiary_birth_date').datepicker('show');
    },
    selectDate4() {
      $('#invoice_date').datepicker('show');
    },
    selectDate5() {
      $('#start_date').datepicker('show');
    },
    selectDate6() {
      $('#end_date').datepicker('show');
    },
    getStates() {
      this.states = Object.keys(statesAndTownship);
      setTimeout(() => {
          setTimeout(() => {
              $('#state').on('change', () => {
                this.detailsData.state = $('#state').val();
                $('#city').val('');
                this.detailsData.city = '';
                this.getTownships();
              });
          }, 1000);
      }, 1000);
    },
    getTownships() {
      this.townships = statesAndTownship[this.detailsData.state];
      setTimeout(() => {
        $('#state').niceSelect('update');
        $('#city').niceSelect('update'); 
          setTimeout(() => {
              $('#city').on('change', () => {
                this.detailsData.city = $('#city').val();
                setTimeout(() => {
                  $('#state').niceSelect('update');
                  $('#city').niceSelect('update'); 
                }, 100);
              });
          }, 100);
      }, 100);
    },
    nextStep2() {
      if ($('#constancy_date').val()) {
        this.detailsData.constancy_date = moment($('#constancy_date').val(), 'DD-MM-YYYY').format('YYYY-MM-DD');
      } 
      // if ($('#birth_date2').val()) {
        //   this.detailsData.birth_date = moment($('#birth_date2').val(), 'DD-MM-YYYY').format('YYYY-MM-DD');
      // } else {
        //   alert('Favor de llenar la fecha de nacimiento');
      //   return
      // }
      if ($('#invoice_date').val()) {
        this.detailsData.invoice_date = moment($('#invoice_date').val(), 'DD-MM-YYYY').format('YYYY-MM-DD');
      }
      this.isLoading = true;
      this.detailsData.marital_status = $('#estado_civil').val();
      this.detailsData.entity = $('#entity').val();
      this.detailsData.vehicle_type = $('#vehicle_type').val();
      this.detailsData.transmission = $('#transmission').val();
      if ($('#beneficiary_birth_date').val()) {
        this.detailsData.beneficiary_birth_date = moment($('#beneficiary_birth_date').val(), 'DD-MM-YYYY').format('YYYY-MM-DD');
      }

      var day = new Date().getDate();
      var month = new Date().getMonth() + 1;
      var year = new Date().getFullYear(); 

      var dataPdf = {
        id_quote: this.dataInsurance.id,
        mother_name: this.detailsData.mother_name,
        last_name: this.detailsData.father_name,
        phone: this.dataContractor.phone,
        email: this.dataContractor.email,
        age: this.dataContractor.age,
        civil_status: this.detailsData.marital_status,
        const_date: this.detailsData.constancy_date,
        birthday: this.dataContractor.birthDay,
        name: this.detailsData.names,
        rfc: this.detailsData.rfc,
        gender: this.dataContractor.gender,
        entity: this.detailsData.entity,
        zip_code: this.detailsData.zip_code,
        street: this.detailsData.street,
        suburb: this.detailsData.suburb,
        state: this.detailsData.state,
        municipality: this.detailsData.city,
        exterior: this.detailsData.exterior_no,
        interior: this.detailsData.interior_no,
        discount: '-1',
        payment: this.dataContractor.paymentMethod,
        // invoice_date: this.detailsData.invoice_date || (year + '-' + month + '-' + this.returnDay(day)),
        invoice_date: this.detailsData.invoice_date,
        end_date: (year + 1) + '-' + month + '-' + this.returnDay(day),
        start_date: year + '-' + month + '-' + this.returnDay(day),
        motor: 'SN',
        model: this.dataContractor.selectedModel,
        license_plate: this.detailsData.plates,
        hedge: 'Amplia',
        serie: this.detailsData.serial_number,
        vehicle_type: this.detailsData.vehicle_type,
        invoice_value: '0',
        origin: 'Web',
        brand: this.dataContractor.selectedBrand,
        year: this.dataContractor.selectedModel,
        transmission: this.detailsData.transmission,
        passengers: this.detailsData.passengers,
        description: this.dataContractor.selectedDescription,
        version: this.dataContractor.selectedVersion,
        cia: this.dataInsurance.cia,
        clave_auto: this.vehicleKey
      }
      if (!this.validateForm()) {
        this.$PolicyService.generateInsurance(dataPdf).then((result) => {
          this.policieId = result.data.id;
          this.policy = result.data.poliza;
          this.pricePolicy = result.data.invoiceValue;
          this.isLoading = false;
          this.step1 = false;
          this.step2 = true;
          window.scrollTo(0, 0);
        }, (err) => {
          alert(err.message);
          this.isLoading = false;
          window.scrollTo(0, 0);
        });
        
      } else {
        let campos = '';
        this.arrayValidations.forEach(item => {
          campos += item + ' ';
        })
        alert(`Favor de completar los campos obligatorios: ${campos}`);
        this.isLoading = false;
      }
    },
    returnDay(day) {
      if (day.toString().length == 1) {
        return '0' + day; 
      } 

      return day;
    },
    nextStep3() {
      this.step2 = false;
      this.step3 = true;
      window.scrollTo(0, 0);
    },
    nextStep4() {
      this.isLoading = true;
      var dataUser = {
        name: this.detailsData.names + ' ' + this.detailsData.father_name + ' ' + this.detailsData.mother_name,
        email: this.dataContractor.email,
        phone_number: this.dataContractor.phone
      };
      if (this.pay_method == 'bank_account') {

        var customerId = '';
        var data = {
          method: 'bank_account',
          customerId: '',
          currency: 'MXN'
        };

        this.$PolicyService.createUser(dataUser).then((res) => {
          customerId = res.data.id;
          data.customerId = customerId;
          this.$PolicyService.payInsurance(data, this.policieId).then((result) => {
            window.open(`https://sandbox-dashboard.openpay.mx/spei-pdf/${this.openpay_id}/${result.data.id}`, '_blank');
            this.isLoading = false;
            alert('Éxito, se ha generado su pago con éxito');
            window.location = '/';
          }, (err) => {
            this.isLoading = false;
            alert(err.message);
          });
        }, (err) => {
          this.isLoading = false;
          alert(err.message);
        });

        
      } else if (this.pay_method == 'card') {
        this.isLoading = false;
        this.step3 = false;
        this.stepCard = true;
      } else {

        var data = {
          method: 'store',
          customerId: '',
          currency: 'MXN'
        }

        this.$PolicyService.createUser(dataUser).then((res) => {
          customerId = res.data.id;
          data.customerId = customerId;
          this.$PolicyService.payInsurance(data, this.policieId).then((result) => {
            window.open(`https://sandbox-dashboard.openpay.mx/paynet-pdf/${this.openpay_id}/${result.data.payment_method.reference}`, '_blank');
            this.isLoading = false;
            alert('Éxito, se ha generado su pago con éxito');
            window.location = '/';
          }, (err) => {
            this.isLoading = false;
            alert(err.message);
          });
        }, (err) => {
          this.isLoading = false;
          alert(err.message);
        });

        
      }
      
    },
    generatePay() {
      this.cardData.type = $('#card_type').val();
      var arrayCard = this.cardData.number.split(' ');
      var arrayExpiry = this.cardData.expiry.split(' ');
      
      var data = {
        card_number: arrayCard[0] + arrayCard[1] + arrayCard[2] + arrayCard[3],
        holder_name: this.cardData.name,
        expiration_year: arrayExpiry[2].slice(2,4),
        expiration_month: arrayExpiry[0],
        cvv2: this.cardData.cvv,
      };
      if (data.card_number) {
        this.isLoading = true;
        this.pay(data);
      }
    },
    initOpenPay() {
      OpenPay.setId(this.openpay_id);
      OpenPay.setApiKey(this.openpay_key);
      OpenPay.setSandboxMode(this.openpay_sandbox_mode);
      this.deviceSessionId = OpenPay.deviceData.setup();
    },
    pay(data) {
      OpenPay.token.create({
        card_number: data.card_number,
        holder_name: data.holder_name,
        expiration_year: data.expiration_year,
        expiration_month: data.expiration_month,
        cvv2: data.cvv2
        
      }, (response) => {
        this.token = response.data.id;
        var data = {
          sourceId : this.token,
          method : "card",
          deviceSessionId : this.deviceSessionId,
          customer : {
            name : this.detailsData.names,
            last_name : this.detailsData.father_name + ' ' + this.detailsData.mother_name,
            phone_number : this.dataContractor.phone,
            email : this.dataContractor.email
          }
        }

        this.$PolicyService.payInsurance(data, this.policieId).then((res) => {
          this.stepCard = false;
          this.stepFinal = true;
          this.isLoading = false;
        }, (err) => {
          alert(err.message);
          this.isLoading = false;
        });
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      });

      
    },
    formatPrice(value) {
      let num = (value/1).toFixed(2);
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    assignData() {
      this.data.fullName = this.dataContractor.fullName;
      this.data.age = this.dataContractor.age;
      this.data.email = this.dataContractor.email;
      this.data.phone = this.dataContractor.phone;
      this.data.gender = this.dataContractor.gender;
      this.data.postcode = this.dataContractor.postcode;
      this.data.paymentMethod = this.dataContractor.paymentMethod;
      this.data.selectedModel = this.dataContractor.selectedModel;
      this.data.selectedBrand = this.dataContractor.selectedBrand;
      this.data.selectedVersion = this.dataContractor.selectedVersion;
      this.data.selectedDescription = this.dataContractor.selectedDescription;
      this.data.id = this.dataInsurance.id;
      this.data.cia = this.dataInsurance.cia;
      this.data.material_damage = this.dataInsurance.material_damage;
      this.data.steal_total = this.dataInsurance.steal_total;
      this.data.initial_payment = this.dataInsurance.initial_payment;
    },
  },
  created() {
    this.assignData();
    this.getStates();
  },
  mounted() {
    this.initOpenPay();
    
    var card = new Card({
      form: '#formId',
      container: '.card-wrapper',

      placeholders: {
        number: '**** **** **** ****',
        name: 'Nombre completo',
        expiry: '**/****',
        cvc: '***'
      }
    });
  }
}
</script>

<style lang="scss">
  .error {
    border-color: red !important;
  }
  
  .post_input_quote{
    position: relative;
    background: #fff;
    border: 1px solid #d3d3d3;
    box-shadow: none;
    outline: none;
    font: 400 16px/40px "Source Sans Pro", sans-serif;
    padding: 0 25px;
    height: auto;
    border-radius: 5px;
    color: rgba(0, 0, 0, 0.6);
    min-width: 100%;
  }

  .post_select_quote {
    position: relative;
    background: #fff;
    border: 1px solid #d3d3d3;
    box-shadow: none;
    outline: none;
    font: 400 16px/40px "Source Sans Pro", sans-serif;
    padding: 0 25px;
    height: 42px;
    border-radius: 5px;
    color: rgba(0, 0, 0, 0.6);
    min-width: 100%;
    // background-color: transparent;
    &:after {
      display: none;
    }
    &:before {
      content: "";
      position: absolute;
      top: 0;
      right: 20px;
      font: normal normal normal 16px/40px FontAwesome;
      color: #151515;
    }
    .list {
      width: 100%;
      border-radius: 0;
      margin: 0;
      border: 0;
      box-shadow: none;
      outline: none;
      box-shadow: 1px 0px 7px 0px rgba(22, 43, 70, 0.1);
    }
  }

  .input-icons2 {
    width: 100%;
    margin-bottom: 0px;
    i {
      position: absolute;
      bottom: 19px;
      right: 8px;
      cursor: pointer;
    }
  }

  .custom-control-label {
    font-size: 20px;
    font-weight: 600;
    padding-left: 10px;
    padding-bottom: 30px;
  }

  /* This is the default state */
  .custom-radio .custom-control-label::before {
    border: 1px solid black;
    width: 20px;
    height: 20px;
  }

  /* This is the checked state */
  .custom-radio .custom-control-input:checked~.custom-control-label::before,
  .custom-radio .custom-control-input:checked~.custom-control-label::after {
    background-color: #f59019 !important; 
    /* this bg image SVG is just a white circle, you can replace it with any valid SVG code */
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E") !important; 
    border-radius: 100% !important;
    width: 20px;
    height: 20px;
  }

  /* active state i.e. displayed while the mouse is being pressed down */
  .custom-radio .custom-control-input:active ~ .custom-control-label::before {
    color: #fff !important;
    background-color: #2759ab !important;
  }

  /* the shadow; displayed while the element is in focus */
  .custom-radio .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(255, 123, 255, 0.25) !important; /* pink, 25% opacity */
  }

  input[type="radio"]:checked~label {
    opacity: 1 !important;
    border: 0px solid transparent !important;
    background-color: transparent !important;
  }

</style>


// WEBPACK FOOTER //
// src/views/QuotationProcess.vue